export default "__VITE_ASSET__66c775c7__"